import LeaderProfile from "./Leader_Profile/LeaderProfile.jsx";
import { ombudsman } from './Leader_Profile/LeaderProfile';

const Ombudsman = () => {
    return (
        <LeaderProfile
            name={ombudsman.name}
            education={ombudsman.education}
            majorActivities={ombudsman.majorActivities}
            collegeIntro={ombudsman.collegeIntro}
            introTwo={ombudsman.introTwo}
            image={ombudsman.image}
            designation={ombudsman.designation}
            secondContent={ombudsman.secondContent}
        />
    )
}

export default Ombudsman
